import './mini-rich-text.scss'
import type { FC } from 'react'

export interface MiniRichTextProps {
    text: string
    className?: string
}
// RichText field without the big size text size of grid
export const MiniRichText: FC<MiniRichTextProps> = ({ text, className }) => (
    <div className={`mini-rich-text ${className}`} dangerouslySetInnerHTML={{ __html: text }} />
)
